module.exports = __webpack_public_path__ + "static/c4265de7.Shipping.png";